export default __webpack_public_path__ + "static/media/Mark-4-Blueprints-02.18a138da.jpg";